export default __webpack_public_path__ + "static/media/c5.6e460cc6.jpg";